import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { todayPagePrompt } from '../data/pagePrompts';

function Home() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const todayPrompt = todayPagePrompt();
  const [answer, setAnswer] = useState('');

  function handleContinue() {
    const draft = {
      prompt: todayPrompt.prompt,
      theme: todayPrompt.theme,
      answer,
      visibility: 'private',
      showOnProfile: false,
      tileFormat: 'square',
      pageName: 'Default',
      entryDate: new Date().toISOString().slice(0, 10),
    };
    localStorage.setItem('cyberautography:pageDraft', JSON.stringify(draft));
    navigate('/dashboard/pages');
  }

  return (
    <>
      <SEO title="Your Life, Your Interface" />
      <section className="hero-grid">
        <div className="hero-copy">
          <p className="eyebrow">Autobiography profiles, made personal</p>
          <h1>Your story should look like it belongs to you.</h1>
          <p className="lead">
            Cyberautography helps people build living autobiographies with pages, prompts, components, timelines, and AI help only
            where they want it.
          </p>
          <div className="button-row">
            <Link className="button" to="/dashboard">Open your workspace</Link>
            <Link className="button button-secondary" to="/marketplace">Explore components</Link>
          </div>
        </div>
        <aside className="memoir-card" aria-label="Autobiography preview">
          <span className="page-label">Today&apos;s page</span>
          <h2>{todayPrompt.prompt}</h2>
          <textarea rows="5" value={answer} onChange={(event) => setAnswer(event.target.value)} placeholder="Write an answer your future self could find again." />
          <div className="button-row compact-row">
            <button className="button" type="button" title={currentUser ? 'Open Pages to post' : 'Log in to post'} onClick={handleContinue}>{currentUser ? 'Continue in Pages' : 'Log in to post'}</button>
          </div>
        </aside>
      </section>
      <section className="feature-grid">
        <article className="surface-card">
          <h2>Public or private</h2>
          <p>Each component can be public, friends-only, or private from the start.</p>
        </article>
        <article className="surface-card">
          <h2>Customize your life</h2>
          <p>Shape the autobiography around your memories, routines, inspirations, pictures, and profile style.</p>
        </article>
        <article className="surface-card">
          <h2>AI when wanted</h2>
          <p>Use AI to organize memories, preserve your voice, and share inspiration across generations.</p>
        </article>
      </section>
    </>
  );
}

export default Home;
